module.exports = __webpack_public_path__ + "img/wdytitle.713c7bb5.png";